import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { parse } from 'cookie';
import initStore from '../store';
import App from '../components/app/containers/AppContainer';

const cookies = parse(document.cookie);
const store = initStore(null, cookies);

const Root = () => (
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

export { store };
export default Root;
